"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderAnchorNavigationAndReturnUnmount = void 0;
var anchor_navigation_comp_1 = require("./anchor-navigation.comp");
var utils_1 = require("../../utils");
exports.renderAnchorNavigationAndReturnUnmount = function (elem, locale, components, onAnchorIdChange) {
    var compProps = { locale: locale, components: components, onAnchorIdChange: onAnchorIdChange };
    return utils_1.renderCompAndReturnUnmount(elem, anchor_navigation_comp_1.AnchorNavigation, compProps);
};
//# sourceMappingURL=anchor-navigation-renderer.js.map